// Geography helpers for the routing map (ported from LogiCast). Visualization
// only — distance/transit drive lane colors, never the routing itself.

/** Great-circle distance between two lat/lng points, in miles. */
export function haversine(lat1: number, lng1: number, lat2: number, lng2: number): number {
  const R = 3958.8; // Earth radius (miles)
  const r = (d: number) => (d * Math.PI) / 180;
  const a =
    Math.sin(r(lat2 - lat1) / 2) ** 2 +
    Math.cos(r(lat1)) * Math.cos(r(lat2)) * Math.sin(r(lng2 - lng1) / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

/** Bucket a mileage into estimated transit days (0..5). */
export const transitDays = (miles: number): number =>
  miles < 1 ? 0 : miles < 300 ? 1 : miles < 700 ? 2 : miles < 1200 ? 3 : miles < 1800 ? 4 : 5;
